import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiMe, apiLogin, apiRegister, apiLogout, apiGoogleSession } from "@/lib/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const u = await apiMe();
      setUser(u);
      return u;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    const hash = window.location.hash || "";
    if (hash.includes("session_id=")) {
      const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
      apiGoogleSession(sid)
        .then((u) => setUser(u))
        .catch(() => {})
        .finally(() => {
          window.history.replaceState(null, "", window.location.pathname);
          setLoading(false);
        });
      return;
    }
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const login = async (payload) => {
    const u = await apiLogin(payload);
    setUser(u);
    return u;
  };
  const register = async (payload) => {
    const u = await apiRegister(payload);
    setUser(u);
    return u;
  };
  const logout = async () => {
    await apiLogout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
